import { React, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Login.css';
import { login, verify_token } from '../api/auth_api';

const Login = () => {
    const navigate = useNavigate();
    const [values, setValues] = useState({
        email: '',
        rememberMe: false
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        const token = localStorage.getItem('authToken');
        const isRemembered = localStorage.getItem('rememberMe') === 'true';

        const checkAutoLogin = async () => {
            if (token && isRemembered) {
                try {
                    // אימות הטוקן מול השרת כפי שביקשה ה-Reviewer
                    await verify_token();
                    navigate('/main_screen');
                } catch (err) {
                    // אם הטוקן פג תוקף או לא תקין - ננקה את הנתונים
                    localStorage.removeItem('authToken');
                    localStorage.removeItem('rememberMe');
                    console.error("Session expired or invalid token");
                    // עדיין למלא את המייל אם נשמר
                    const rememberedEmail = localStorage.getItem('rememberedEmail');
                    if (rememberedEmail) {
                        setValues(prev => ({
                            ...prev,
                            email: rememberedEmail,
                            rememberMe: true
                        }));
                    }
                }
            } else {
                // אם לא זוכרים, נבדוק אם יש מייל שמור רק כדי להקל על ההקלדה
                const rememberedEmail = localStorage.getItem('rememberedEmail');
                if (rememberedEmail) {
                    setValues(prev => ({
                        ...prev,
                        email: rememberedEmail,
                        rememberMe: true
                    }));
                }
            }
        };

        checkAutoLogin();
    }, [navigate]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setValues(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        const { email, rememberMe } = values;
        const password = e.target.password.value;
        try {
            const response = await login(email, password);
            
            // 2. חילוץ הטוקן מהתשובה של השרת
            const token = response?.token || response?.data?.token;

            if (token) {
                // אנחנו תמיד שומרים את הטוקן כדי שהמשתמש יוכל לגלוש באתר כרגע
                localStorage.setItem('authToken', token);
                
                // אנחנו שומרים את בחירת המשתמש האם לזכור אותו לפעם הבאה
                localStorage.setItem('rememberMe', rememberMe ? 'true' : 'false');
                
                if (rememberMe) {
                    localStorage.setItem('rememberedEmail', email);
                } else {
                    localStorage.removeItem('rememberedEmail');
                }
            }

            navigate(`/main_screen`);
        } catch (err) {
            const serverMessage = err.response?.data?.message;
            const fallbackMessage = 'קרתה שגיאה. נסה שוב מאוחר יותר';
            const finalMessage = serverMessage || fallbackMessage;
            setError(finalMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <form onSubmit={handleSubmit} className="login-form">
                <h2 className="login-title">התחברות</h2>

                <div className="form-group">
                    <label>אימייל</label>
                    <input 
                        type="email" 
                        name="email" 
                        value={values.email} 
                        onChange={handleChange} 
                        required 
                    />
                </div>

                <div className="form-group">
                    <label>סיסמה</label>
                    <input type="password" name="password" required />
                </div>

                <div className="remember-me-container">
                    <label>
                        <input 
                            type="checkbox" 
                            name="rememberMe" 
                            checked={values.rememberMe} 
                            onChange={handleChange} 
                        />
                        <span>זכור אותי</span>
                    </label>
                </div>

                {error && (
                    <div className="error-message" style={{
                        color: '#e74c3c',
                        fontSize: '14px',
                        marginBottom: '15px',
                        textAlign: 'center',
                        padding: '8px',
                        backgroundColor: '#ffeaea',
                        borderRadius: '4px',
                        border: '1px solid #e74c3c'
                    }}>
                        {error}
                    </div>
                )}

                <button type="submit" className="connect-btn" disabled={loading}>
                    {loading ? (
                        <>
                            <div style={{ 
                                width: '20px', 
                                height: '20px', 
                                border: '2px solid #EF5DA8', 
                                borderTop: '2px solid transparent', 
                                borderRadius: '50%', 
                                animation: 'spin 1s linear infinite',
                                marginLeft: '8px'
                            }}></div>
                            מתחבר...
                        </>
                    ) : (
                        <>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#EF5DA8"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                style={{ marginLeft: '8px' }}
                            >
                                <path d="M20 21v-2a4 4 0 0 0-3-3.87" />
                                <path d="M4 21v-2a4 4 0 0 1 3-3.87" />
                                <circle cx="12" cy="7" r="4" />
                            </svg>
                            התחבר
                        </>
                    )}
                </button>
                <div className="forgot-password">
                    <span onClick={() => navigate('/forgot_password')}>
                        שכחת סיסמה?
                    </span>
                </div>
            </form>
        </div>
    );
};

export default Login;
